import React from 'react';
import { Upload, X } from 'lucide-react';
import { useDropzone } from 'react-dropzone';
import { cn } from '../../../../../lib/utils';
import { usePhotoUpload } from '../../hooks/usePhotoUpload';

export const PhotoUploader: React.FC = () => {
  const { handleUpload } = usePhotoUpload();
  const [error, setError] = React.useState<string | null>(null);

  const onDrop = async (acceptedFiles: File[]) => {
    setError(null);
    const uploadError = await handleUpload(acceptedFiles);
    if (uploadError) setError(uploadError);
  };

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      'image/jpeg': ['.jpg', '.jpeg'],
      'image/png': ['.png'],
    },
    maxSize: 5 * 1024 * 1024, // 5MB
  });

  return (
    <div className="space-y-4">
      <div 
        {...getRootProps()} 
        className={cn(
          "border-2 border-dashed rounded-lg p-8 text-center transition-colors",
          isDragActive ? "border-primary-500 bg-primary-50" : "border-gray-300",
          "dark:border-gray-600 dark:hover:border-gray-500"
        )}
      >
        <input {...getInputProps()} />
        <div className="flex flex-col items-center">
          <Upload className="h-12 w-12 text-gray-400 mb-4" />
          <p className="text-lg font-medium text-gray-700 dark:text-gray-300">
            Glissez-déposez vos photos ici
          </p>
          <p className="text-sm text-gray-500 dark:text-gray-400 mt-2">
            ou cliquez pour sélectionner des fichiers
          </p>
          <p className="text-xs text-gray-400 dark:text-gray-500 mt-1">
            JPG, JPEG, PNG • 5MB max par photo • 20 photos maximum
          </p>
        </div>
      </div>

      {error && (
        <div className="rounded-md bg-red-50 p-4 dark:bg-red-900/20">
          <div className="flex">
            <X className="h-5 w-5 text-red-400" />
            <div className="ml-3">
              <h3 className="text-sm font-medium text-red-800 dark:text-red-200">
                Erreur lors du téléchargement
              </h3>
              <div className="mt-2 text-sm text-red-700 dark:text-red-300">
                {error}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};